/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import RecipeListRow from "./RecipeListRow";


export default function RecipeListGroup({homepage, group, showPercentageValues, translate}) {

    return (
        <React.Fragment>

            {group && group.groupTotalLabel && <tr>
                <th className={`${homepage.rtlLanguage ? 'text-right' : 'text-left'} p-table-head`}
                    colSpan={showPercentageValues ? "3" : "2"}>
                    {group.groupTotalLabel}
                </th>
            </tr>}

            {group && group.ingredients && group.ingredients.map((ingredient, index) =>
                <RecipeListRow key={ingredient.ingredientLabel} row={ingredient} translate={translate}
                               showAddToCart={homepage.enableRecipeAddToCart} position={index + 1}
                               showPercentageValues={showPercentageValues}/>
            )}

            {group && !group.hideTotalUnits && <tr className="info">
                <td className="p-table-text">{group.groupTotalLabel} {translate("Total")}</td>
                <td className="text-right p-table-text">{group.groupTotalUnits}</td>
                {showPercentageValues && <td className="text-right p-table-text"></td>}
            </tr>}

        </React.Fragment>
    );

}
